import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {

    // disable browser restore
    window.history.scrollRestoration = "manual";

    // smooth reverse scroll to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

  }, [pathname]);

  return null;
};

export default ScrollToTop;